import {UD_FAILURE, UD_PENDING, UD_SUCCESS} from './constants'
//import {getUserDetails as getUserDetailsApi} from '../../services/auth'
import detailsJson from '../../fixtures/user_details.json'

const sanitizePermissions = permissions => {
  return {
    ...permissions,
    canCreate: permissions['allow_to_create_audit'] ? true : false,
  }
}

const getUserDetails = async dispatch => {
  dispatch({type: UD_PENDING})
  try {
    // const response = await getUserDetailsApi()

    dispatch({type: UD_SUCCESS, payload: sanitizePermissions(detailsJson)})
  } catch (e) {
    console.log(`Get User Details Failed: ${e}`)
    dispatch({type: UD_FAILURE, payload: e})
  }
}

export default getUserDetails
